import styled from 'styled-components'

const AboutUsStyle = styled.div.attrs({})`
    margin-top: var(--sp15x);
    padding:0 var(--sp8x);

    .our-team {
        width: 83%;
        text-align:center;

        & > .comp-title:nth-child(2){
            max-width: 80%;
        }

        .team {
            margin-top:var(--sp4x);
            width: 100%;
            .single-member {
                width: calc(25% - (30%/4));

                &:nth-child(4n-3) {
                    margin-right:5%;
                }
                &:nth-child(4n-2) {
                    margin-right:5%;
                    margin-left:5%;
                    margin-top:var(--sp5x);
                }
                &:nth-child(4n-1) {
                    margin-right:5%;
                    margin-top:var(--sp5x);
                    margin-left:5%;
                }
                &:nth-child(4n) {
                    margin-left:5%;
                }

                .imageCont {
                    width: 100%;
                    padding-top: 100%;
                    border-radius:var(--sp3x);
                    overflow:hidden;
                }

                .name {
                    margin:var(--sp3x) 0 var(--spSize);
                }
            }
        }
    }

    .solution {
        align-items: flex-start;
        max-width: var(--sp136x);
        width:100%;

      

        .sols {
            /* width: 85%; */
            margin-top: 2%;

           .single-solution {
            justify-content:space-between;
            .info {
                width:47%;
            }
            .imageCont {
                 width: 47%;
                padding-top: 32%;

            img {
                object-fit: contain;
            }
          }
           }
        }
    }

    @media only screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}){
        margin-top: var(--sp3x);
        padding:0 var(--sp2x);

        .our-team {
            width: 100%;

            .team {
                margin-top:var(--sp4x);
                width: 100%;
                flex-wrap:wrap;

                .single-member {
                    width: calc(50% - var(--spSize));
                    text-align:center;
                    margin-top:var(--sp4x);

                    &:nth-child(2n) {
                        margin-left:var(--spSize) !important;
                    }
                    
                    &:nth-child(2n-1) {
                        margin-right:var(--spSize) !important;
                    }

                    &:nth-child(4n-3) {
                        margin-right:0;
                    }
                    &:nth-child(4n-2) {
                        margin-right:0;
                        margin-left:0;
                        margin-top:inherit;
                    }
                    &:nth-child(4n-1) {
                        margin-right:0;
                        margin-top:inherit;
                        margin-left:0;
                    }
                    &:nth-child(4n) {
                        margin-left:0;
                    }

                    .name {
                        margin:var(--sp2x) 0 var(--spSize);
                    }
                }
            }
        }

        .solution {
            align-items: flex-start;
            max-width: unset;
            width:100%;

            .imageCont {
                width: 100%;
                padding-top: 74%;
                margin-right: 0;

                img {
                    object-fit: contain;
                }
            }

            .sols {
                width: 100%;
                text-align: center;
                
                .single-solution {
                    margin-top: var(--sp3x);
                }
            }
        }
    }
`
export default AboutUsStyle
